export default __webpack_public_path__ + "static/media/consumer.4e86995f.png";